import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { queryClient } from "../../main.jsx";
import { Button } from "../../common/Button.tsx";
import { activeIntegrationsSelector } from "../../reducers/index.js";


export function UpdateStatistics() {

    const { t } = useTranslation();
	const activeIntegrations = useSelector(activeIntegrationsSelector);
	const isProcountorActive = !!activeIntegrations.tokenProcountor;
    
	return <Row>
		<Col sm="8" align="right">
		{!isProcountorActive && (
			<Button
				testId="update"
				variant="primary"
				//disabled={isLoading}
				onClick={() =>
				queryClient.invalidateQueries({
					queryKey: [isProcountorActive ? "procountorEmployeeExpanded" : "vacancy"],
				})
				}
			>
				{t("Update", "Päivitä")}
			</Button>
		)}
		</Col>
	</Row>;
}